import { request } from "./transport";

export interface EconomicEvent {
  readonly id: number;
  readonly event: string;
  readonly date: string;
  readonly time: string;
  readonly release_id: string | null;
}

export interface EconomicEventsWindow {
  /** ISO date (YYYY-MM-DD), inclusive. */
  readonly from: string;
  /** ISO date (YYYY-MM-DD), inclusive. */
  readonly to: string;
}

export const economicEvents = {
  listEconomicEvents: ({ from, to }: EconomicEventsWindow) =>
    request<{ events: EconomicEvent[] }>(
      `/economic_events?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    ),
};
